import React, { useMemo } from '../../../_snowpack/pkg/react.js';
import { Link } from '../../../_snowpack/pkg/react-router-dom.js';
import LoadingSpinner from '../../modules/loading-spinner.js';
import { useQuery } from '../../../_snowpack/pkg/@apollo/react-hooks.js';
import { H2 } from '../../css/index.js';
import DocumentTitle from '../../modules/document-title/index.js';
import ImgSlack from '../../images/illustrations/dashboard-community.svg';
import ImgInvite from '../../images/illustrations/dashboard-invite.svg';
import ImgLearn from '../../images/illustrations/dashboard-learn.svg';
import ImgExperts from '../../images/illustrations/dashboard-experts.svg';
import { useTenant, useTenantPlan, useUserRole, useLanguage } from '../../hooks/index.js';
import { GET_WIZARD_DATA } from './graph.js';
import { Outer, Inner, H1, Header, Grid, CardInner, EmptyWizard, Card } from './styles.js';
import Wizard from './wizard/index.js';
import { ActivateAccount } from './activate-account.js';
const greetings = ['So good to have you here.', 'We really like to have you here.', 'You are the joy of our life', 'Great to see you'];

const CrystallizeHome = () => {
  var _user$firstName;

  const {
    tenant,
    user
  } = useTenant();
  const {
    language
  } = useLanguage();
  const role = useUserRole();
  const tenantPlan = useTenantPlan();
  const today = useMemo(() => new Date().toISOString(), []);
  const {
    data,
    loading
  } = useQuery(GET_WIZARD_DATA, {
    variables: {
      tenantId: tenant.id,
      today,
      language
    }
  });
  return /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(DocumentTitle, {
    title: "Home"
  }), /*#__PURE__*/React.createElement(Inner, null, /*#__PURE__*/React.createElement(Header, {
    "data-cypress": "home-heading"
  }, /*#__PURE__*/React.createElement(H1, null, "Hello ", (_user$firstName = user === null || user === void 0 ? void 0 : user.firstName) !== null && _user$firstName !== void 0 ? _user$firstName : 'stranger', ", ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, greetings[Math.floor(Math.random() * greetings.length)]))), !loading && tenantPlan.status === 'loaded' ? /*#__PURE__*/React.createElement(React.Fragment, null, !tenantPlan.hasActivated && role === 'tenantAdmin' && /*#__PURE__*/React.createElement(ActivateAccount, {
    tenant: tenant
  }), /*#__PURE__*/React.createElement(Wizard, data)) : /*#__PURE__*/React.createElement(EmptyWizard, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadingSpinner, {
    size: 20,
    strokeSize: 4
  }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", null, "\"A ", /*#__PURE__*/React.createElement("strong", null, "wizard"), " is never late nor is he early he arrives precisely when he means to\"")))), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement("a", {
    href: "https://join.slack.com/t/crystallizecommunity/shared_invite/zt-bn8cpxiv-FH4~TAFiXYYDEVrxBHWXbA",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(Card, {
    cssShadow: true,
    borderRadius: 8
  }, /*#__PURE__*/React.createElement(CardInner, null, /*#__PURE__*/React.createElement("img", {
    src: ImgSlack,
    alt: "Illustration of a bunch of people cheering and high fiving"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H2, null, "Join the community"), /*#__PURE__*/React.createElement("p", null, "Share experiences with other users or ask the crystallize team directly in our slack workspace"))))), /*#__PURE__*/React.createElement("a", {
    href: "https://crystallize.com/learn#book-a-demo",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(Card, {
    cssShadow: true,
    borderRadius: 8
  }, /*#__PURE__*/React.createElement(CardInner, null, /*#__PURE__*/React.createElement("img", {
    src: ImgExperts,
    alt: "Illustration of a girl and a guy waving"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H2, null, "Need help with building your webshop?"), /*#__PURE__*/React.createElement("p", null, "Book a free consulting session with an expert, maybe we or our partners can help you out."))))), /*#__PURE__*/React.createElement("a", {
    href: "https://crystallize.com/learn",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(Card, {
    cssShadow: true,
    borderRadius: 8
  }, /*#__PURE__*/React.createElement(CardInner, null, /*#__PURE__*/React.createElement("img", {
    src: ImgLearn,
    alt: "Illustration of an octopus holding a document in each tentacle"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H2, null, "Resources & guides to get you started"), /*#__PURE__*/React.createElement("p", null, "Share experiences with other users or ask the crystallize team directly in our slack workspace"))))), /*#__PURE__*/React.createElement(Link, {
    to: `/settings/tenants/${tenant === null || tenant === void 0 ? void 0 : tenant.identifier}/users`
  }, /*#__PURE__*/React.createElement(Card, {
    cssShadow: true,
    borderRadius: 8
  }, /*#__PURE__*/React.createElement(CardInner, null, /*#__PURE__*/React.createElement("img", {
    src: ImgInvite,
    alt: "A girl and a guy sending a paper airplane"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H2, null, "Invite your friends"), /*#__PURE__*/React.createElement("p", null, "Creating is more fun with friends, invite your team to your tenant"))))))));
};

export default CrystallizeHome;